export default __webpack_public_path__ + "static/media/AllProductItems11.a40d3844.png";